import { lazy } from "common/load/componentUtils";

import { CloseProp, useDialog, useDrawer } from "client/common/hooks/stackables";

import type { RemoveCartItemDialogProps } from "../components/RemoveCartItemDialog";
import type { RefillTooSoonDrawerProps } from "../components/RefillTooSoonDrawer";

const RemoveCartItemDialog = lazy(() => import("../components/RemoveCartItemDialog"));
const RefillTooSoonDrawer = lazy(() => import("../components/RefillTooSoonDrawer"));

export const useRemoveCartItemDialog = () => {
  const { open } = useDialog();
  return {
    open: (props: RemoveCartItemDialogProps & CloseProp) => open(RemoveCartItemDialog, props),
  };
};

export const useRefillTooSoonDrawer = () => {
  const { open } = useDrawer();
  return {
    open: (props: RefillTooSoonDrawerProps) => open(RefillTooSoonDrawer, props),
  };
};
